import { CustomAxiosError } from '@calm/evexia-web-sdk';
import { MINUTE_MS } from '@calm/web-common/dist/time';
import createPartnerApi from '@rhg/libs/api/create-partner-api';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export const publicBrandingPartnerConfigQueryOptions = {
    queryKey: (accessCode: string) => {
        return [queryKeys.publicBrandingPartnerConfig, accessCode];
    },
    queryFn: async (uniqCode: string) => {
        const partnerApi = createPartnerApi(() => Promise.resolve(''));

        const response = await partnerApi
            .getBrandingPartnerConfig({
                uniqCode,
            })
            .catch((e: CustomAxiosError) => {
                if (e?.response?.status === 404) {
                    return { data: null };
                } else {
                    throw e;
                }
            });

        return response.data;
    },
    queryOptions: (uniqCode: string) => {
        return {
            enabled: !!uniqCode,
            staleTime: 15 * MINUTE_MS,
            retry: false,
        };
    },
};

export function usePublicBrandingPartnerConfig(accessCode = '') {
    const { queryKey, queryFn, queryOptions } =
        publicBrandingPartnerConfigQueryOptions;
    const options = queryOptions(accessCode);

    const { data, ...otherProps } = useQuery({
        queryKey: queryKey(accessCode),
        queryFn: async () => queryFn(accessCode),
        ...options,
    });
    return {
        brandingPartnerConfig: data,
        ...otherProps,
        enabled: options.enabled,
    };
}
